export const coursConstants = {
  GET_COURS: "GET_COURS",
  GET_COUR: "GET_COUR",
  GET_AVENANT: "GET_AVENANT",

  GET_EMARGEMENTS: "GET_EMARGEMENTS",
  GET_EMARGEMENT: "GET_EMARGEMENT",
};
